import { OrderCostInfoDTO, CartCostTypeEnum } from '@on-arte/core-types';

export function getCostFinalPriceByType(costs: OrderCostInfoDTO[], type: CartCostTypeEnum): number {
  return costs.find((cost: OrderCostInfoDTO): boolean => cost.type === type)?.finalPrice ?? 0;
}
